<template>
  <v-footer
    id="home-footer"
    color="black"
    dark
    min-height="72"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
            <template v-for="(s, i) in social">
              <a
                :key="s.name"
                class="white--text pa-1 pa-md-0"
                :href="s.url"
                v-text="s.name"
              />

              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s.name}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </div>
        </v-col>

        <v-col
          class="text-center text-md-right"
          cols="12"
          md="6"
        >
          &copy; {{ new Date().getFullYear() }} All rights reserved | Web Chair: <a href="mailto:giusy.iaria@polito.it">Giusy Iaria</a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      social: [
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/ETS-Conference-669254046517645/',
        },
        {
          name: 'Twitter',
          url: 'https://twitter.com/IEEE_ETS',
        },
        {
          name: 'Telegram',
          url: 'https://t.me/IEEE_ETS',
        },
        {
          name: 'Linkedin',
          url: 'https://www.linkedin.com/groups/8794779/',
        },
      ],
    }),
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
